export let current = (_d={}) => {
    return `<em class="controlbar-time-current">00:00</em>`;
};

export let total = (_d={}) => {
    return `<span class="controlbar-time-duration">00:00</span>`;
};